// theme-sources/js/elements/home-slideshow.js
import Swiper from "swiper";
import { EffectFade, Thumbs, Autoplay, Pagination } from "swiper/modules";

const DEBUG = false;
const logger = {
  info(message, payload) {
    if (typeof window === "undefined") return;
    if (window.__ZIGGY_DEBUG__ !== true) return;
    if (!DEBUG) return;
    console.info(`[HomeSlideshow] ${message}`, payload ?? "");
  },
};

function initHomeSlideshow() {
  const root = document.querySelector(".slideshow-2025");
  if (!root) return;

  logger.info("init");

  const delay = Number(root.dataset.delay) || 3500;

  const imageContainer = root.querySelector(".hero-image-swiper");
  const textContainer = root.querySelector(".hero-text-swiper");

  if (!imageContainer || !textContainer) {
    logger.warn("missing swiper containers");
    return;
  }

  const imageSwiper = new Swiper(imageContainer, {
    modules: [EffectFade],
    effect: "fade",
    speed: 1000,
    allowTouchMove: false,
    loop: false,
  });

  const textSwiper = new Swiper(textContainer, {
    modules: [Thumbs, Autoplay, Pagination],
    loop: true,
    speed: 1000,
    autoplay: {
      delay,
      disableOnInteraction: false,
    },
    pagination: {
      el: root.querySelector(".swiper-2025-pagination"),
      clickable: true,
    },
    thumbs: {
      swiper: imageSwiper,
    },
  });

  return { imageSwiper, textSwiper };
}

initHomeSlideshow();
